import Pristine from 'pristinejs';
import { load } from 'recaptcha-v3';

import '../sass/citrus-single-property-details.scss';

(() => {
    const $citrusSinglePropertyDetails = document.querySelectorAll('.citrus-single-property-details');

    if (!$citrusSinglePropertyDetails) return;

    const { RECAPTCHA_V3_SITE_KEY } = GLOBALS;

    $citrusSinglePropertyDetails.forEach($citrusSinglePropertyDetails => {
        const $map = $citrusSinglePropertyDetails.querySelector('.citrus-single-property-details__map');
        const $ctaBrochuresForm = $citrusSinglePropertyDetails.querySelector('.citrus-single-property-details__cta-brochures-form');

        const initMap = () => {
            if (!$map) return;

            const { lat, lng } = $map?.dataset;

            if (!lat || !lng) return;

            const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));

            const map = new google.maps.Map($map, {
                center: position,
                zoom: 10,
                disableDefaultUI: true,
                zoomControl: true,
            });
    
            const marker = new google.maps.Marker({
                position,
                map
            });
        };

        const initCtaBrochuresFormValidation = () => {
            if (!$ctaBrochuresForm) return;

            const pristine = new Pristine($ctaBrochuresForm);
        
            $ctaBrochuresForm.addEventListener('submit', e => {
                e.preventDefault();

                if ($ctaBrochuresForm.classList.contains('citrus-single-property-details__cta-brochures-form--loading')) return;

                $ctaBrochuresForm.classList.add('citrus-single-property-details__cta-brochures-form--loading');

                if (!pristine.validate()) {
                    $ctaBrochuresForm.classList.remove('citrus-single-property-details__cta-brochures-form--loading');

                    return;
                }

                const $recaptchaTokenInput = $ctaBrochuresForm.querySelector('.recaptcha-token');

                if (RECAPTCHA_V3_SITE_KEY && $recaptchaTokenInput) {
                    load(RECAPTCHA_V3_SITE_KEY).then((recaptcha) => {
                        recaptcha.execute('contact').then((token) => {
                            $recaptchaTokenInput.value = token;

                            $ctaBrochuresForm.submit();
                            
                            $ctaBrochuresForm.classList.remove('citrus-single-property-details__cta-brochures-form--loading');
                        });
                    });
                } else {
                    $ctaBrochuresForm.submit();

                    $ctaBrochuresForm.classList.remove('citrus-single-property-details__cta-brochures-form--loading');
                }
            });
        };

        initMap();
        initCtaBrochuresFormValidation();
    });
})();
